import { Appearance } from '@/types';
import { getIsDieCutStickerPrintType } from '@/model/printType/getIsDieCutStickerPrintType';
import { getPrintTypesOfAppearance } from './getPrintTypesOfAppearance';

export function getIsDieCutStickerAppearance(appearance: Appearance) {
  return getPrintTypesOfAppearance(appearance).every(getIsDieCutStickerPrintType);
}
